import { EventEmitter } from '@angular/core';
var startData = {
    style: {
        imageContainer: {
            transform: 'scale(1)',
        },
        imageContainerHandler: {
            transform: 'translate(0px, 0px)',
        },
        cursor: {
            cursor: 'grab',
        },
        imageContainerAndHandler: {
            transform: 'translate(0px, 0px) scale(1)',
        },
    },
    scale: 1,
    translate: { x: 0, y: 0 },
    oldTranslate: { x: 0, y: 0 },
    isMouseDown: false,
    mouseClickPos: { x: 0, y: 0 },
};
var ZoomHelper = /** @class */ (function () {
    function ZoomHelper() {
        this.zoom = Object.assign({}, startData);
        this.scaleChange = new EventEmitter();
    }
    Object.defineProperty(ZoomHelper.prototype, "step", {
        get: function () {
            return Math.floor(this.zoom.scale * 10) / 100;
        },
        enumerable: true,
        configurable: true
    });
    ZoomHelper.prototype.mouseMove = function ($event) {
        if (!this.zoom.isMouseDown) {
            return;
        }
        this.zoom.translate = {
            x: this.zoom.oldTranslate.x + ($event.clientX - this.zoom.mouseClickPos.x),
            y: this.zoom.oldTranslate.y + ($event.clientY - this.zoom.mouseClickPos.y),
        };
        this.updateZoom();
    };
    ZoomHelper.prototype.mouseDown = function ($event) {
        this.zoom.isMouseDown = true;
        this.zoom.style.cursor.cursor = 'grabbing';
        this.zoom.mouseClickPos = {
            x: $event.clientX,
            y: $event.clientY,
        };
    };
    ZoomHelper.prototype.mouseUp = function () {
        this.zoom.isMouseDown = false;
        this.zoom.style.cursor.cursor = 'grab';
        this.zoom.oldTranslate = this.zoom.translate;
    };
    ZoomHelper.prototype.zoomImage = function ($event) {
        if ($event.deltaY < 0) {
            this.zoomIn();
        }
        else {
            this.zoomOut();
        }
        this.scaleChange.emit(this.zoom.scale);
    };
    ZoomHelper.prototype.updateZoom = function () {
        if (this.zoom.scale <= 0.1) {
            this.zoom.scale = 0.1;
        }
        var scaleString = "scale(" + this.zoom.scale + ")";
        var translateString = "translate(" + this.zoom.translate.x + "px, " + this.zoom.translate.y + "px)";
        this.zoom.style.imageContainer.transform = scaleString;
        this.zoom.style.imageContainerHandler.transform = translateString;
        this.zoom.style.imageContainerAndHandler.transform = scaleString + ' ' + translateString;
    };
    ZoomHelper.prototype.zoomIn = function () {
        this.zoom.scale += this.step;
        this.updateZoom();
    };
    ZoomHelper.prototype.zoomOut = function () {
        this.zoom.scale -= this.step;
        this.updateZoom();
    };
    ZoomHelper.prototype.resetStyles = function () {
        this.zoom = Object.assign({}, startData);
        this.updateZoom();
    };
    return ZoomHelper;
}());
export { ZoomHelper };
